// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLinesWarehouseSharedStyles from "@tps/App/SharedStyles/CartLinesWarehouseStyles";
import { cartLinesStyles } from "@tps/Overrides/Widgets/Cart/CartLines";
import { mergeWithCss } from "@tps/XDL/Utilities";
import { css } from "styled-components";

cartLinesStyles.headerWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 16px;
        &:empty {
            display: none;
        }
        margin-bottom: 16px;
    `,
};

cartLinesStyles.cartLinesWarehouseStyles = {
    ...cartLinesWarehouseSharedStyles,
};

cartLinesStyles.notify = {
    css: css`
        margin-bottom: 0;
    `,
};

cartLinesStyles.shippingCommentStyle = {
    ...mergeWithCss(cartLinesWarehouseSharedStyles?.shippingOptionStyle, {
        extendedStyles: {
            wrapper: {
                css: css`
                    margin-bottom: 12px;
                `,
            },
        },
    }),
};
